// removed by extract-text-webpack-plugin
module.exports = {"scrollable":"OpenDesignModal__scrollable"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OpenDesignModal/OpenDesignModal.scss
// module id = ./src/components/OpenDesignModal/OpenDesignModal.scss
// module chunks = 2